import React, { useEffect, useState } from 'react';

export const BillContent = ({ customerName, currentOrder, totalAmountBeforeDiscount, totalDiscount, finalAmount, paymentMethod, paymentStatus }) => {
    const [userInfo, setUserInfo] = useState(null);    
      useEffect(() => {
        const storedUserInfo = localStorage.getItem("user");
        if (storedUserInfo) {
          const parsedUserInfo = JSON.parse(storedUserInfo);
          setUserInfo(parsedUserInfo);
        }
      }, []);
    
  return (
    <div id="bill-content">
        <div className="text-center">
              {userInfo && (
                <>
                  <h4 className="m-0 p-0">{userInfo.organizationInfo.name}</h4>
                  <p className="m-0 p-0">{userInfo.organizationInfo.address1}</p>
                  <p className="m-0 p-0">Phone: {userInfo.user.phoneNumber}</p>
                </>
              )}
              </div>
      <p className='m-0 p-0'>Customer Name: {customerName}</p>
      <p className='m-0 p-0'>Payment Method: {paymentMethod}</p>
      <p className='m-0 p-0'>Payment Status: {paymentStatus}</p>
      <table className="table mb-0">
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {currentOrder.map((item) => (
            <tr key={item.id}>
              <td>{item.title}</td>
              <td>{item.quantity}</td>
              <td>Rs. {item.price}</td>
              <td>Rs. {item.totalPrice}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className='text-end my-1'>
      <p className='p-0 m-0'>Total Amount Before Discount: Rs. {Number(totalAmountBeforeDiscount).toFixed(2)}</p>
      <p className='p-0 m-0'>Total Discount: Rs. {totalDiscount.toFixed(2)}</p>
      <hr className='p-0 m-0 my-1' />
      <p className='p-0 m-0'>Final Amount: Rs. {Number(finalAmount).toFixed(2)}</p>
      </div>
      <div className='text-center'>
        <p className='p-0 m-0'>Thank You!</p>
        <p className='p-0 m-0'>Visit Us Again!!!</p>
      </div>
    </div>
  );
};